var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-body-extra-small',{staticClass:"pc-form-workout-log__text-set-complete",attrs:{"line-height":"multi"}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }